import { useState } from "react";
import { newBrand } from "../../redux/apiCalls";


export default function NewBrand() {
    const [inputs, setInputs] = useState({});

    const handleChange = (e) => {
        setInputs((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handleClick = async (e) => {
        const brand = { ...inputs };
        e.preventDefault();
        try {
            newBrand({ brand });
        } catch (err) {
            console.log(err);
        }
    }

    return (
        <>
            <div className="newProduct">
                <h1 className="addProductTitle">New Brand</h1>
                <div className="addProductForm">
                    <div className="addProductItem">
                        <label className="black required">Name</label>
                        <input
                            name="name"
                            type="text"
                            placeholder="Name"
                            onChange={handleChange}
                        />
                    </div>
                    <button onClick={handleClick} className="updateProductButton">
                        Create
                    </button>
                </div>
            </div>
        </>
    );
}
